import React from 'react';
import registerReact from 'utils/registerReact';

/**
 * React components
 */
import XfactorNav from 'components/XfactorNav/XfactorNav';

const LimitedLines = React.lazy(() =>
  import('./components/LimitedLines/LimitedLines')
);

const Season = React.lazy(() => import('./components/Season/Season'));
const PeoplePaging = React.lazy(() =>
  import('./components/PeoplePaging/PeoplePaging')
);

const VideoThumbList = React.lazy(() =>
  import('./components/VideoThumbList/VideoThumbList')
);

const Video = React.lazy(() => import('./components/Video/Video'));

export default () => {
  registerReact('main-nav-component', XfactorNav);
  registerReact('limited-lines-component', LimitedLines);
  registerReact('video-thumb-list-component', VideoThumbList);
  registerReact('season-component', Season);
  registerReact('people-paging-component', PeoplePaging);
  registerReact('video-component', Video);
};
